import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";
const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-copyright">
      <div className="content">
        <p>{t("copyRight.message")}</p>
      </div>
    </div>
  );
};
export default Footer;
